import { css, styled } from '@flex-design-system/stitches-react';
import { fadeAnimation } from './keyframes.mjs';

const overlayStyle = css({
  position: "fixed",
  inset: 0,
  /**
   * Portal Container에 따라 position: fixed or absolute를 갖는데, 항상 container영역을 채울 수 있도록
   * width, height를 100%로 설정하는 스타일을 추가한다.
   */
  width: "100%",
  height: "100%",
  "@motion": {
    animationTimingFunction: fadeAnimation.timingFunction,
    animationDuration: fadeAnimation.duration.open,
    '&[data-state="open"]': {
      animationName: fadeAnimation.show()
    },
    '&[data-state="closed"]': {
      animationDuration: fadeAnimation.duration.close,
      animationName: fadeAnimation.hide()
    }
  },
  variants: {
    overlayTheme: {
      light: {
        backgroundColor: "$overlayLight"
      },
      dark: {
        backgroundColor: "$overlayDark"
      },
      transparent: {
        backgroundColor: "transparent"
      }
    }
  }
});
styled("div", {});

export { overlayStyle };
//# sourceMappingURL=css.mjs.map
